// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-Spacer_cls1__F2g6E","cls2":"VeloActionBar-Spacer_cls2__7j6Uq VeloActionBar-Spacer_cls1__F2g6E"};